import styled from '@emotion/styled';
import { TabletWidth } from '../../../global.style';
import { getColor } from '../../common/UICommon';

export const PickLabelsContainer = styled.div<{ imgDesktop: string }>`
  background-image: url(${({ imgDesktop }) => imgDesktop});
  background-size: cover;
  background-position: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  @media (max-width: ${TabletWidth}px) {
    padding: 66px 24px 16px;
    background-image: none;
    background-color: ${getColor('BEIGE_10')};
  }
`;

export const PickLabelsWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${TabletWidth}px) {
    height: 100%;
  }
`;

export const PickLabelsMainContent = styled.div`
  margin-top: 180px;
  width: 100%;
  padding: 0;
  overflow: auto;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;

  @media (max-height: 760px) {
    margin-top: auto;
  }

  @media (max-width: ${TabletWidth}px) {
    margin-top: auto;
    height: calc(100% - 71px);
  }
`;

export const PickLabelsAnswersWrapper = styled.div`
  width: 100%;
  max-width: 700px;
  margin-bottom: 8px;

  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  height: 308px;

  @media (max-width: ${TabletWidth}px) {
    display: block;
    max-width: 330px;
  }
`;

export const PickLabelsButtonWrapper = styled.div`
  margin: 42px auto 88px;
  max-width: 330px;
  width: 100%;

  @media (max-width: ${TabletWidth}px) {
    margin: 24px auto 24px;
  }
`;

export const PickLabelsTitle = styled.div`
  color: ${getColor('BLACK')};
  font-family: Lora;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 32px;
  text-align: left;
  margin-bottom: 4px;
  text-align: center;
`;

export const PickLabelsSubtitle = styled.div`
  color: ${getColor('GRAY_80')};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 32px;
  text-align: center;
  margin-bottom: 24px;

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 38px;
  }
`;

export const PickLabelsAnswerBtn = styled.button`
  font-family: Poppins;
  width: 100%;
  background-color: ${getColor('WHITE')};
  color: ${getColor('BEIGE_95')};
  border-radius: 100px;
  border: 1px solid ${getColor('WHITE')};
  padding: 16px 23px;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 500;
  justify-content: space-between;
  max-width: 330px;
  max-height: 52px;

  &:hover {
    border: 1px solid ${getColor('BEIGE_30')};
  }

  &.selected {
    background-color: ${getColor('BEIGE_20')};
    border: 1px solid ${getColor('BEIGE_20')};
  }

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 12px;
  }
`;

export const PickLabelsAnswerBox = styled.img`
  width: 18px;
  height: 18px;
`;

export const PickLabelsFadeEffect = styled.div`
  display: none;

  @media (max-width: ${TabletWidth}px) {
    position: absolute;
    bottom: 87px;
    width: 100%;
    height: 48px;
    background: linear-gradient(180deg, rgba(240, 234, 228, 0) 0%, ${getColor('BEIGE_10')} 100%);
    display: block;
    pointer-events: none;
  }
`;
